import { User } from '@monsido/modules/models/api/user';

export class UserForm extends User {
    password?: string;
    password_confirmation?: string;
    reseller_admin?: boolean;
}
